import { AnyType } from 'types/common';
import { SUBPATH_NAMES, SUBPATH_PARAMS } from 'constants/common';
import { POS_PATH } from 'constants/pos';

export const returnValueOrNull = (value: AnyType): AnyType => value || null;

const encodeQueryParam = ({
  contentId,
  contentSlug,
}: {
  contentId: string;
  contentSlug: string;
}): string =>
  encodeURIComponent(`${contentId}${contentSlug ? `-${contentSlug}` : ''}`);

export const addSlugToUrl = ({
  contentId,
  contentSlug,
  isPos = false,
  subPath,
}: {
  contentId: string;
  contentSlug: string;
  isPos?: boolean;
  subPath: string;
}): {
  pathname: string;
  query?: {
    articleSlug?: string;
    sectionSlug?: string;
  };
} => ({
  pathname: `${isPos ? POS_PATH : ''}${SUBPATH_NAMES[subPath] as string}`,
  ...(contentId
    ? {
        query: {
          [SUBPATH_PARAMS[subPath]]: encodeQueryParam({
            contentId,
            contentSlug,
          }),
        },
      }
    : {}),
});

export const determineCanonicalTag = ({
  locale,
  subPath,
  pageSlug,
  contentId,
  contentSlug,
}: {
  locale: string;
  subPath: string;
  pageSlug: string;
  contentId: string;
  contentSlug: string;
}): boolean | string =>
  pageSlug !== `${contentId}-${contentSlug}` &&
  `${process.env.SITE_BASEURL}/${locale}${
    contentSlug
      ? `/${subPath}/${contentId}-${contentSlug}`
      : `/${subPath}/${contentId}`
  }`;

export const createPathFromArray = (parts: string[]): string =>
  parts.reduce((acc, cur) => `${acc}/${cur}`, '');
